// extracted by mini-css-extract-plugin
export var chip = "_9t-0";
export var filterDropdown = "_9t-5";
export var filterItem = "_9t-6";
export var icon = "_9t-1";
export var removeButton = "_9t-3";
export var removeIcon = "_9t-4";
export var separator = "_9t-2";